import React from 'react'

import { Panel } from '@pb/components'

import styles from './ExpandedOrder.scss'
import OrderActions from './OrderActions'
import OrderEntries from './OrderEntries'
import OrderSummary from './OrderSummary'

type ExpandedOrderProps = {
  order: any
  runKlarnaOp: any
  isTargetApp: boolean
}

const ExpandedOrder: React.FC<ExpandedOrderProps> = ({ order, runKlarnaOp, isTargetApp }) => (
  <Panel padding="0 m m" paddingMedium="m" className={styles.container}>
    <OrderEntries
      products={order.products}
      returnedProducts={order.returnedProducts}
      isTargetApp={isTargetApp}
    />
    <OrderSummary order={order} />
    {order.operations.length > 0 && (
      <OrderActions
        orderOperations={order.operations}
        runKlarnaOp={runKlarnaOp}
        orderId={order.orderId}
      />
    )}
  </Panel>
)

export default ExpandedOrder
